import { ReviewSearchParamsDto } from '@/contracts/marketplace/reviews';
import { BrandGroupEntity } from '@/entities/brand-group.entity';
import { ProductGroupEntity } from '@/entities/product-group.entity';
import { ReviewEntity } from '@/entities/review.entity';
import { useReducer } from 'react';
import { createInitialReviewsPageState } from '@/context/reviews-page.state';
import { reviewsPageReducer } from '@/context/reviews-page.state-machine';
import { useReviewsPageActions } from '@/context/use-reviews-page-actions';

type UseReviewsPageStateArgs = {
    totalReviews: number;
    reviews: ReviewEntity[];
    products: ProductGroupEntity[];
    brandGroups: BrandGroupEntity[];
    filters: ReviewSearchParamsDto;
    reviewsOnPage: number;
};

export const useReviewsPageState = ({
    totalReviews,
    reviews,
    products,
    brandGroups,
    filters,
    reviewsOnPage,
}: UseReviewsPageStateArgs) => {
    const [state, dispatch] = useReducer(
        reviewsPageReducer,
        createInitialReviewsPageState({
            totalReviews,
            reviews,
            products,
            brandGroups,
            filters,
            reviewsOnPage,
        }),
    );

    const actions = useReviewsPageActions(dispatch);

    return {
        state,
        ...actions,
    };
};
